import * as React from 'react';

require('../css/radio.css');

interface Props {
  id: string;
  group: string;
  label?: string;

  // Adding a property to add external css class. 
  inputClassName?: string;
  labelClassName?: string;

  defaultChecked: boolean;
  onChange(checked: boolean): void;
}

class Radio extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleMiddle = (e: React.MouseEvent<HTMLInputElement>) => {
    this.props.onChange(e.currentTarget.checked);
  };

  render() {
    // Check if external css properties comes from parent
    let inputUserClass = this.props.inputClassName === null ? '' : this.props.inputClassName;
    let labelUserClass = this.props.labelClassName === null ? '' : this.props.labelClassName;

    return (
      <>
        <input
          className={`with-gap ${inputUserClass}`}
          name={this.props.group}
          type="radio"
          id={this.props.id}
          defaultChecked={this.props.defaultChecked}
          onClick={this.handleMiddle}
        />
        <label className={labelUserClass} htmlFor={this.props.id}>{this.props.label}</label>
      </>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/Components/Radio.tsx